var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { attrs: { role: "region", "aria-label": "Become a creator values" } },
    [
      _c("box", { attrs: { huge: "" } }, [
        _c(
          "div",
          { staticClass: "_flexcol _gap-6" },
          [
            _c("become-a-creator-values-title"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "_grid _grid-cols-2 _grid-cols-4--m _tac _jc-c _gap-4 _gap--6--m",
                attrs: { role: "list" },
              },
              _vm._l(_vm.benefits, function (value) {
                return _c(
                  "values-section-item",
                  _vm._b(
                    { key: value.title, attrs: { role: "listitem" } },
                    "values-section-item",
                    value,
                    false
                  )
                )
              }),
              1
            ),
            _vm._v(" "),
            _vm.$displayMode.isWeb
              ? _c(
                  "div",
                  { staticClass: "_tac _mt-2" },
                  [
                    _c(
                      "base-link",
                      {
                        staticClass:
                          "gfu-btn gfu-btn--primary gfu-btn--soft _ttu",
                        attrs: { url: _vm.becomeACreatorUrl },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.Resources.Homepage.BecomeACreatorButton
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "become-a-creator-stats",
              _vm._b(
                {
                  staticClass: "_bt-1 _bc--light",
                  attrs: { layout: "extranarrow" },
                },
                "become-a-creator-stats",
                _vm.creatorStatistics,
                false
              )
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }